import React from 'react';
import { FaWhatsapp } from 'react-icons/fa';

import styles from './whatsapp-button.module.scss';

export const WhatsappButton = () => {
    return (
        <div className={styles.container}>
            <a
                href='https://api.whatsapp.com/send?phone=56999846063&text=IDAI-Hola,%20me%20gustar%C3%ADa%20recibir%20asesoramiento.'
                aria-label="whatsapp-link"
                target='_blank' rel="noreferrer"
            >
                <FaWhatsapp className={styles.icon} />
            </a>
        </div>
    );
};